import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { CreditCard, X, AlertTriangle } from "lucide-react";
import { Link } from "wouter";
import { useState } from "react";

interface BillingNudgeProps {
  user: any;
  organization: any;
}

export function BillingNudge({ user, organization }: BillingNudgeProps) {
  const [dismissed, setDismissed] = useState(false);

  // Don't show if organization doesn't have past_due status or if dismissed
  if (!organization || organization.subscriptionStatus !== "past_due" || dismissed) {
    return null;
  }

  // Check if user is owner (can take action)
  const isOwner = user?.isOwner || user?.role === "owner";

  return (
    <Alert className="border-orange-200 bg-orange-50 mb-4">
      <AlertTriangle className="h-4 w-4 text-orange-600 mt-2" />
      <div className="flex items-center justify-between w-full">
        <div className="flex-1">
          <AlertDescription className="text-orange-800">
            <span className="font-medium">Payment Issue:</span> There is a billing issue with your organization's subscription that needs immediate attention. Service may be interrupted if not resolved promptly.
            {!isOwner && (
              <span className="block text-sm mt-1 text-orange-700">
                Please contact your organization owner to resolve this payment issue.
              </span>
            )}
          </AlertDescription>
        </div>
        <div className="flex items-center gap-2 ml-4">
          {isOwner ? (
            <Link href="/billing">
              <Button
                size="sm"
                className="bg-orange-600 hover:bg-orange-700 text-white"
              >
                <CreditCard className="h-4 w-4 mr-2" />
                Resolve Payment
              </Button>
            </Link>
          ) : (
            <Button
              size="sm"
              variant="outline"
              disabled
              className="text-orange-600 border-orange-300"
            >
              <CreditCard className="h-4 w-4 mr-2" />
              Contact Owner
            </Button>
          )}
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setDismissed(true)}
            className="text-orange-600 hover:text-orange-700 hover:bg-orange-100"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </Alert>
  );
}